import { create } from 'zustand';

interface MessageState {
  showMessage: boolean;
  setShowMessage: (showMessage: boolean) => void;
  message: string;
  setMessage: (message: string) => void;
}

export const useMessageStore = create<MessageState>(set => ({
  showMessage: false,
  message: '',
  setShowMessage: (showMessage: boolean) => {
    set({ showMessage });
    if (showMessage) {
      setTimeout(() => {
        set({ showMessage: false });
      }, 10000);
    }
  },
  setMessage: (message: string) => set({ message })
}));
